module.exports = __webpack_public_path__ + "static/media/history.253f9f2b.bin";